import { Link } from 'react-router-dom';

const LOGO = 'https://customer-assets.emergentagent.com/job_87cd0f70-4f18-4348-a2fd-e2666a61734d/artifacts/ozrawt0t_IMG_0439.jpeg';

export default function Footer({ settings }) {
  return (
    <footer className="bg-[hsl(240_6%_7%)] border-t border-border">
      <div className="container-x py-10 grid gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Link to="/" className="flex items-center gap-2 notranslate" translate="no">
            <img src={LOGO} alt="AlveeTrade" className="h-9 w-9 rounded-lg gold-hairline" />
            <div className="font-display uppercase text-xl">AlveeTrade</div>
          </Link>
          <p className="text-sm text-muted-foreground mt-3 max-w-md">
            AlveeTrade (formerly AlveeFX) is an educational trading community. We share forex signals, mentorship,
            and market breakdowns to help traders build consistency.
          </p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-3">Navigate</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-muted-foreground hover:text-white transition-colors">Home</Link></li>
            <li><a href="/#pricing" className="text-muted-foreground hover:text-white transition-colors">Pricing</a></li>
            <li><a href="/#videos" className="text-muted-foreground hover:text-white transition-colors">Reviews</a></li>
            <li><Link to="/giveaways" className="text-muted-foreground hover:text-[hsl(43_92%_56%)] transition-colors" data-testid="footer-giveaways-link">Giveaways</Link></li>
            <li><Link to="/blog" className="text-muted-foreground hover:text-white transition-colors" data-testid="footer-blog-link">Blog</Link></li>
            <li><a href="/#faq" className="text-muted-foreground hover:text-white transition-colors">FAQ</a></li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/disclaimer" data-testid="footer-disclaimer-link" className="text-muted-foreground hover:text-white transition-colors">Disclaimer</Link></li>
          </ul>
          <p className="text-xs text-muted-foreground mt-5 max-w-md leading-relaxed">
            All content is for educational purposes. Trading carries risk. You alone are responsible for your decisions.
          </p>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="container-x py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-muted-foreground">
          <div>© {new Date().getFullYear()} AlveeTrade. All rights reserved.</div>
          <div>Trading. Reimagined.</div>
        </div>
      </div>
    </footer>
  );
}
